import Login from './login';
import LoginFaq from './login/login.faq';
import LoginSecurity from './login/login.security';
import LoginContactUs from './login/login.contact.us';
import ChangePassword, {
  ChangePasswordSuccess,
  NewUserChangePassword
} from '../change-password';

export default {
  Login,
  ChangePassword,
  ChangePasswordSuccess,
  NewUserChangePassword,
  LoginFaq,
  LoginSecurity,
  LoginContactUs
};
